export default __webpack_public_path__ + "static/media/vegan-food-and-beverage-products.d042f2fc.png";